import { render, staticRenderFns } from "./AbilitySystemType.vue?vue&type=template&id=28d3b9ef&scoped=true"
import script from "./AbilitySystemType.vue?vue&type=script&lang=js"
export * from "./AbilitySystemType.vue?vue&type=script&lang=js"
import style0 from "./AbilitySystemType.vue?vue&type=style&index=0&id=28d3b9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3b9ef",
  null
  
)

export default component.exports